export const H265_MIN_IOS_SAFARI_VERSION = '11.0'
export const H265_MIN_IOS_VERSION = '11'
export const H265_MIN_OSX_SAFARI_VERSION = '11.1'
export const H265_MIN_OSX_VERSION = '10.13'
export const VP9_MIN_CHROME_VERSION = '50.0'
